export const singleBreakpoints = {
  0: {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 16
  },
  768: {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 50
  }
};
